import { Component, NgZone } from '@angular/core';
import { BridgeService, NotificationService, SessionState, WindowService } from '@myvf/core';
import { filter } from 'rxjs/operators';
import { Store } from '@ngxs/store';
import { NativeAchorEnum } from '../../native-anchor';
import { TealiumAnalyticsService } from '../../tagging/tealium/tealium-analytics.service';
import { TealiumModel } from '@myvf/shared';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'myvf-notification',
  templateUrl: './notification.component.html',
})
export class NotificationComponent {
  message = 'Servizio non disponibile';
  isShow = false;

  constructor(
    private service: NotificationService,
    private win: WindowService,
    private bridge: BridgeService,
    private store: Store,
    private tealium: TealiumAnalyticsService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private ngZone: NgZone
  ) {
    this.service
      .notification$
      .pipe(
        filter(n => n !== null),
      )
      .subscribe(data => {
        this.ngZone.run(() => {
          this.isShow = true;
          this.message = data || this.message;
          this.tagging();
        });
      });
  }

  handleClose() {
    const { isOverlay } = this.store.selectSnapshot(SessionState);
    if (this.router.url.indexOf('agreements/consents.html?fromSetup=true') > 0) {
      this.bridge.closeOverlay({ parameters: { error: true }, tryBack: false });
    } else if (isOverlay) {
      this.bridge.closeOverlay({});
    } else {
      this.bridge.manageUrlScheme(NativeAchorEnum.HOMEPAGE);
    }
    this.isShow = false;
  }

  handleRetry() {
    this.isShow = false;
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
    this.router.navigate([], { queryParams: this.activateRoute.snapshot.queryParams });
  }

  tagging() {
    this.tealium.push('view', {
      page: {
        pageInfo: {
          pageName: 'MyVodafoneBusiness:Error',
        },
        category: {
          subCategory1: 'Error',
        },
        attributes: {
          pageError: this.message,
          pageErrorCode: `500 | ${this.message}`,
        },
      },
      event: [{
        eventInfo: { eventName: 'page_error' },
        category: { eventName: 'error' },
      }],
    } as TealiumModel);
  }
}

